module.exports = __webpack_public_path__ + "img/image13.ae1f9abe.png";